var _a;
import React, { useState } from 'react';
import styled from 'styled-components';
const logo = (_a = require('./autenti-logo.svg')) === null || _a === void 0 ? void 0 : _a.default;
export const Nav = styled.nav `
  color: ${(props) => props.theme.fontColor};
  border-bottom: 1px solid ${(props) => props.theme.headerBorder};
  border-radius: 0;
  font-size: ${(props) => props.theme.fontXXSmall};
  z-index: 99;
  height: ${(props) => props.height};
  .navbar-header {
    min-height: 35px;
  }
  .autenti-logo {
    height: 20px;
  }
  .intro-text {
    padding: 5px 0 0 0;
    margin: 0;
  }

  @media (min-width: 768px) {
    .navbar-header {
      min-height: 45px;
      width: 100%;
    }
  }
`;
const Header = ({ text, showLogo, hideTextOnMobile, height, showShadow, wrapperClassName, headerClassName, headerText, wrapperTextClassName, senderLogo, senderLogoClassName, }) => {
    const [logoError, setLogoError] = useState(false);
    return (React.createElement(Nav, { className: "Header header navbar", height: height, showShadow: showShadow },
        React.createElement("div", { className: wrapperClassName || 'container-fluid' },
            React.createElement("div", { className: `navbar-header d-flex ${headerClassName ||
                    ' justify-content-center align-items-center text-center flex-row'}` },
                showLogo && (React.createElement("img", { src: logo, alt: "logo", className: "autenti-logo header-autenti-logo" })),
                React.createElement("div", { className: wrapperTextClassName || '' },
                    text && (React.createElement("p", { className: `intro-text ${hideTextOnMobile ? 'hidden-md-down' : ''}` }, text)),
                    headerText && React.createElement("p", { className: "header-text" }, headerText))),
            !logoError && senderLogo && (React.createElement("div", { className: ` ${senderLogoClassName} sender-logo col-4 col-xl-4 d-lg-block d-xl-block` },
                React.createElement("img", { onError: () => setLogoError(true), src: senderLogo, alt: "sender logo" }))))));
};
Header.defaultProps = {
    text: ' ',
    showLogo: true,
    hideTextOnMobile: true,
    height: 'auto',
    showShadow: true,
};
export default Header;
